import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DataTable from '../../components/DataTable/DataTable';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { toast } from 'react-toastify';
import messages from '../../utils/messages';
import customLogger from "../../utils/customLogger.js";
import { useAuth } from '../../context/AuthContext.js';
import { getFileNameFromUrl } from '../../utils/FileUtil';
import * as html2pdf from 'html2pdf.js';

const PreviewSave = ({ data, additionalInfo, onPrepAnother, onBackToDashboard, additionalParamMap, fileStatusData }) => {
  //data = [{"UniqueID":"4a17dc00-99d1-4931-beff-12ec9cba1827","filesUrl":"[\"https://n8n.sentrihub.com/webhook/public/session-files/?path=4a17dc00-99d1-4931-beff-12ec9cba1827/REVIEW_UNSUPPORTED_2025_20260122_002.html\"]"}]
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [tableData, setTableData] = useState([]);
  const [additionalParams, setAdditionalParams] = useState({});
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [savedToSecureFolder, setSavedToSecureFolder] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);
  //const [docType, setDocumentType] = useState('auditor_assistant');
  // Fix: Initialize from either additionalInfo OR fileStatusData (for previous job flow)
  const [docType, setDocumentType] = useState(
    additionalInfo?.documentType || fileStatusData?.documentType
  );
  const [auditorFilesList, setAuditorFilesList] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(true); // loading state
  const [conversionError, setConversionError] = useState(false);
  
  var auditorResponse = [];
  /* = [
    {
        "UniqueID": "ead1adc0-9def-494c-ba7f-ac7d846fd170",
        "filesUrl": "[\"https://n8n.sentrihub.com/webhook/public/session-files/?path=ead1adc0-9def-494c-ba7f-ac7d846fd170/REVIEW_1099INT_2025_20260122.html\"]"
    }
  ]*/
 
 //console.log('Doc Type in PreviewSave:', docType);
  if(docType === 'auditor_assistant' || docType === 'timesheet_qb_enterprise') {
    // Fix: Use fileStatusData.data if available (previous job flow), otherwise use data prop
    auditorResponse = fileStatusData?.data?.length ? fileStatusData.data : data;
  }

  useEffect(() => {
    console.log('SD**', fileStatusData.status)
    const handleResize = () => setIsMobile(window.innerWidth <= 575);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fix: Update docType when fileStatusData loads (for previous job flow)
  useEffect(() => {
    if (fileStatusData?.documentType && !docType) {
      setDocumentType(fileStatusData.documentType);
    }
  }, [fileStatusData?.documentType]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://n8n.sentrihub.com/webhook';
  const {
    REACT_APP_ENV
  } = process.env;

  useEffect(() => {
    setSelectedPatient(additionalParamMap.patient);
    // Get data from location state if available, otherwise use props
    const processedData = location.state?.processedData || data || [];

    // Initialize with a deep copy of the incoming data
    setTableData(JSON.parse(JSON.stringify(processedData)));
    if (fileStatusData?.data?.length) {
      // showPleaseWait(true);
      if (fileStatusData.status === "SUCCESS")
        setTableData(fileStatusData?.data);
    }

    setAdditionalParams(additionalInfo);
  }, [data, location.state, fileStatusData]);

  const handleDataChange = (newData) => {
    setTableData(newData);
  };

  const handleDownload = () => {
    if (!tableData || tableData.length === 0) return;

    if (docType === 'auditor_assistant' || docType === 'timesheet_qb_enterprise') {
      // Download all auditor files as a zip
      if (!auditorFilesList || auditorFilesList.length === 0) {
        toast.error('No files available to download.');
        return;
      }
      const zip = new JSZip();
      auditorFilesList.forEach(file => {
        // file.base64 is base64 string, file.name is filename
        zip.file(file.name, file.base64, { base64: true });
      });
      zip.generateAsync({ type: 'blob' })
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'files.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          toast.success(messages.notifications.FILE_DOWNLOAD_SUCCESSFULL);
        })
        .catch(error => {
          toast.error(messages.errors.FILE_DOWNLOAD_FAIL);
        });
      return;
    }

    // Default: Excel download for other docTypes
    // Specify the columns you want to exclude
    const columnsToExclude = ['UniqueID', 'DocID','ID'];

    // Filter out the unwanted columns
    const filteredData = tableData.map(row => {
      const filteredRow = {};
      for (const key in row) {
        if (!columnsToExclude.includes(key)) {
          filteredRow[key] = row[key];
        }
      }
      return filteredRow;
    });

    try {
      // Create a worksheet from the filtered data
      const worksheet = XLSX.utils.json_to_sheet(filteredData);

      // Create a new workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Generate a buffer
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

      // Create a blob and trigger download
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      if(additionalParams?.documentType){
        link.setAttribute('download', additionalParams.documentType + ".xlsx");
      }else{
        link.setAttribute('download', fileStatusData.documentType + ".xlsx");
      }
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      // Show success toast
      toast.success(messages.notifications.FILE_DOWNLOAD_SUCCESSFULL);
    } catch (error) {
      // Show error toast if something goes wrong
      toast.error(messages.errors.FILE_DOWNLOAD_FAIL);
      //console.error(error);
    }
  };

  function showPleaseWait(show) {
    const waitDiv = document.getElementById('pleaseWaitDiv');
    if (show) {
      waitDiv.classList.remove('d-none');
    } else {
      waitDiv.classList.add('d-none');
    }
  }

  const handleSaveToFolder = async () => {
    try {
      setLoading(true);
      const enableMockServices = process.env.REACT_APP_ENABLE_MOCK_SERVICES === 'true';

      if (enableMockServices) {
        // Mock save to secure folder for testing
        // customLogger.log('MOCK MODE: Using mock save to secure folder');

        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Simulate successful save
        setSavedToSecureFolder(true);
        toast.success(messages.notifications.DATA_SAVED_TO_SECURE_FOLDER);
        return;
      }

      // Real API implementation
      // customLogger.log('Using real API endpoint for save to secure folder');

      // Get the token from localStorage
      const token = localStorage.getItem('auth_token');

      const requestBody = {
        "analytics_workspace_name": additionalParamMap.companyName,
        "filename": additionalParams.filename || fileStatusData.fileName,
        "patientid": selectedPatient?.patientId || fileStatusData.patientId,
        "first_name": selectedPatient?.firstName || fileStatusData.firstName,
        "last_name": selectedPatient?.lastName || fileStatusData.lastName,
        "doc_type": additionalParams.documentType || fileStatusData.documentType ,        
        "uniqueid": tableData[0]?.UniqueID,
        "jsondata": (docType === 'auditor_assistant' || docType === 'timesheet_qb_enterprise') ? auditorFilesList : tableData.map(({ UniqueID,ID, ...rest }) => rest)
      }

        customLogger.log("zerobalance-dataprep -> PreviewSave -> handleSaveToFolder -> Request from React to n8n", JSON.stringify(requestBody))
        const response = await fetch(`${API_BASE_URL}/save-secure?env=${encodeURIComponent(REACT_APP_ENV)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          },
          body: JSON.stringify(requestBody)
        });

        if (response.ok) {
          let responseData = await response.text();
          responseData = JSON.parse(responseData);
          customLogger.log("zerobalance-dataprep -> PreviewSave -> handleSaveToFolder -> Response from n8n to react", responseData)
          if(responseData && responseData.success) {
            setSavedToSecureFolder(true);
            /*** Showing toast on success */
            toast.success(messages.notifications.DATA_SAVED_TO_SECURE_FOLDER);
          }
        } else {
          const errorResponse = await response.json();
          customLogger.log("zerobalance-dataprep -> PreviewSave -> handleSaveToFolder -> Error from n8n to react", errorResponse)
          if(response.status === 401) {
            //toast.error(messages.errors.SESSION_EXPIRED);
            logout();
            setTimeout(() => {
              navigate('/unauthorized', { state: { authFailed: true } });
            }, 0);
          } else {
            let errorMsg = errorResponse.Description || messages.errors.FAILED_TO_SAVE_DATA_TO_SECURE_FOLDER;
            throw new Error(errorMsg);
          }
        }
    } catch (error) {
      customLogger.log("zerobalance-dataprep -> PreviewSave -> handleSaveToFolder -> Error in react", error)
      toast.error(error.message || messages.errors.FAILED_TO_SAVE_DATA_TO_SECURE_FOLDER);
    } finally {
      setLoading(false);
    }
  };

  // Calculate Base64 size in KB
  const getBase64SizeInKB = (base64String) => {
    let padding = 0;
    if (base64String.endsWith("==")) padding = 2;
    else if (base64String.endsWith("=")) padding = 1;
    return Math.ceil((base64String.length * 3) / 4 - padding) / 1024;
  };

  // Convert Blob to Base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  // Convert HTML to PDF Blob, then Base64
  const convertHtmlToPdfBase64 = async (htmlContent, fileName) => {
    const container = document.createElement('div');
    container.innerHTML = htmlContent;
    //container.style.position = 'absolute';
    //container.style.left = '-9999px';
    document.body.appendChild(container);

    try {
      // Generate PDF (output as Uint8Array)
      const pdfData = await html2pdf()
        .set({
          margin: 0.5,
          filename: fileName,
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        })
        .from(container)
        .output('blob');

      // Wrap output in Blob
      const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });

      // Convert Blob to Base64
      const base64 = await blobToBase64(pdfBlob);

      return { base64: base64.split(',')[1], blob: pdfBlob };
    } finally {
      document.body.removeChild(container);
    }
  };

  // Main conversion function for a list of links
  const convertLinksToBase64 = async (links, authToken) => {
    const base64List = [];

    try {
      for (const link of links) {
        try {
          // Fetch HTML content from the link
          const response = await fetch(link, {
            headers: authToken ? { 'Authorization': authToken } : {}
          });
          let htmlContent = await response.text();

          // Extract file name from URL
          const rawName = getFileNameFromUrl(link) || `file-${base64List.length + 1}`;
          const fileName = rawName.replace(/\.[^/.]+$/, "") + ".pdf";

          const { base64, blob } = await convertHtmlToPdfBase64(htmlContent, fileName);
          const sizeInKB = getBase64SizeInKB(base64);

          base64List.push({
            name: fileName,
            type: 'application/pdf',
            size: `${sizeInKB.toFixed(2)} KB`,
            base64,
          });

          console.log(`Converted HTML to PDF Base64 for link: ${link}`);
        } catch (error) {
          console.error('Error converting HTML to PDF Base64:', link, error);
          throw error;
        }
      }

      setAuditorFilesList(base64List);
      setLoadingFiles(false);
      return base64List;
    } catch (error) {
      console.error('Error in convertLinksToBase64:', error);
      setConversionError(true);
      setLoadingFiles(false);
      return [];
    }
  };

  useEffect(() => {
    const fetchFiles = async () => {
      if(docType === 'auditor_assistant' || docType === 'timesheet_qb_enterprise') {
        setLoadingFiles(true);
        if(auditorResponse && auditorResponse.length > 0 && auditorResponse[0] && auditorResponse[0].filesUrl) {
          //console.log('fetching files:', JSON.stringify(auditorResponse[0].filesUrl, null, 2));
          await convertLinksToBase64(JSON.parse(auditorResponse[0].filesUrl), localStorage.getItem('auth_token'));
        } else {
          setLoadingFiles(false);
        }
      } else {
        setLoadingFiles(false);
      }
    };
    fetchFiles();
  }, [docType]);

  return (
    <div className="container">
      <h1>Data Prep: Tax and Financial PDF</h1>
      <p className="success-message">{(fileStatusData.status === 'SUCCESS' || fileStatusData.status === 'FAILED')
        ? "Your previous job is ready! Your data has been converted to a downloadable format."
        : "Success! Your data has been converted to a downloadable format."}</p>

      <p className="instruction-message">You can preview your file below, download, and save to a secure folder.</p>

      <p className="warning-message">All data will be purged and lost when you move from this screen unless saved to secure folder.</p>

      <div className="action-buttons d-flex flex-wrap">
        <button
          onClick={handleDownload}
          className='app-primary-btn'
          disabled={tableData.length === 0}
        >
          <small><b>Download File</b></small>
        </button>

        <button
          onClick={handleSaveToFolder}
          disabled={loading || savedToSecureFolder || tableData.length === 0}
          className="app-success-btn ms-lg-5 mt-2 mt-lg-0"
        >
          <small><b>{savedToSecureFolder ? 'Saved' : (loading ? 'Saving...' : 'Save to Secure Folder')}</b></small>
        </button>
      </div>

      {loading && (
        <div style={{ textAlign: 'center', margin: '20px 0', color: '#09A3D9', display: 'flex', textAlign: 'center', justifyContent: 'center' }}>
          <div className="spinner-border" role="status" style={{ marginRight: '10px' }}></div>
          <div style={{ marginTop: '3px' }}>Your file is being saved...</div>
        </div>
      )}

      {/*console.log("this is before preview ",auditorFilesList)*/}
      <DataTable
        data={tableData}
        onDataChange={handleDataChange}
        auditorFilesData={auditorFilesList}
        docType={docType}
        loadingFiles={loadingFiles}
        conversionError={conversionError}
        isMobile={isMobile} />

      <div className="nav-buttons d-flex flex-wrap">
        <button className="app-primary-outline-btn" onClick={() => {
          if (onPrepAnother) {
            onPrepAnother();
          }
          navigate('/upload', { state: { from: "preview" } });
        }}>
          <small><b>Prep Another File</b></small>
        </button>
        {!additionalParamMap?.isPreselected && (
          <button
            className="app-success-outline-btn ms-lg-5 mt-2 mt-lg-0"
            onClick={() => {
              if (onBackToDashboard) {
                onBackToDashboard();
              }
            }}
          >
            <small><b>Back to Dashboard</b></small>
          </button>
        )}
      </div>
    </div>
  );
};

export default PreviewSave;
